// The c/{customerID} collections a customer's views listen across: their own,
// plus every company they belong to when the customer is the one logged in.
// An employee viewing a customer's account on their behalf sees just that
// customer's.
export function customerScope(state, customerID) {
  const ids = [customerID];
  if (state.user && state.user.id === customerID) {
    ids.push(...Object.keys(state.claims.employeeOf || {}));
  }
  return ids;
}
